import {
  RefCommunicationTemplateListParams,
  RefCommunicationTemplatePageResponse,
} from "@/types/refCommunicationTemplate";
import { IRefCommunicationTemplatesService } from "./IRefCommunicationTemplatesService";

/** The template endpoint has no text search, so lists need every page. */
export const getAllTemplatePages = async (
  service: IRefCommunicationTemplatesService,
  parameters: Omit<RefCommunicationTemplateListParams, "page"> = {},
): Promise<RefCommunicationTemplatePageResponse> => {
  const content: RefCommunicationTemplatePageResponse["content"] = [];
  let page = 0;
  let totalPages: number;

  do {
    if (parameters.signal?.aborted) {
      throw new DOMException("Aborted", "AbortError");
    }
    const response = await service.getAll({ ...parameters, page });
    content.push(...response.content);
    totalPages = response.page.totalPages;
    page += 1;
  } while (page < totalPages);

  return {
    content,
    page: {
      size: content.length,
      number: 0,
      totalElements: content.length,
      totalPages: 1,
    },
  };
};
